import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Tabs,
  Tab,
  Typography,
  Card,
  CardContent,
  MenuItem,
  IconButton,
} from "@mui/material";

import { useTheme } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Header from "../../components/Header";
import { tokens } from "../../theme";
import { useNavigate } from "react-router-dom";
import { iepaProd } from "../../constants/global";
import { useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";

const CreateItemLocation = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [activeTab, setActiveTab] = useState(0); // To manage active tab
  const navigate = useNavigate(); // For page navigation

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null); //Error
  const [isLoading, setIsLoading] = useState(false);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleFormSubmit = (values, { resetForm }) => {
    const data = {
      // id: selectedId, // Uncomment if you're using selectedId
      building: values.building,
      floor: values.floor,
      name: values.door,
      orgId: "1",
      createdBy: 1,
      warehouse: { id: 1 },
    };

    setIsLoading(true);

    fetch(
      `${iepaProd.iepaInventorySrvAPI}/inventory/warehouse/container/save`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }
    )
      .then((response) => {
        if (!response.ok) {
          // If response is not OK, throw an error
          return Promise.reject(`Error: ${response.statusText}`);
        }
        return response.json(); // Parse JSON if response is OK
      })
      .then((data) => {
        // Success handling
        setMessage("Item Location added successfully!");
        setError(null); // Clear any previous error
        resetForm(); // Reset the form after successful submission
      })
      .catch((error) => {
        // Error handling
        setError("Failed to add Item Location. Please try again.");
        setMessage(null); // Clear any success message
      })
      .finally(() => {
        // Set loading state to false once done
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setLoading(true);
  }, []);

  const handleClose = () => {
    navigate("/ItemLocList"); // Redirect to /CustomerList
  };

  const tabContent = [
    {
      label: "Item Location Details",
      content: (
        <Formik
          initialValues={initialValues}
          validationSchema={overviewSchema}
          onSubmit={handleFormSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            resetForm,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box display="flex" flexDirection="column" gap="20px" mt="20px">
                <TextField
                  fullWidth
                  required
                  id="building"
                  label="Building"
                  value={values.building}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.building && Boolean(errors.building)}
                  helperText={touched.building && errors.building}
                />
                <TextField
                  fullWidth
                  required
                  id="floor"
                  label="Floor"
                  value={values.floor}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.floor && Boolean(errors.floor)}
                  helperText={touched.floor && errors.floor}
                />
                <TextField
                  fullWidth
                  required
                  id="door"
                  label="Door No."
                  value={values.door}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.door && Boolean(errors.door)}
                  helperText={touched.door && errors.door}
                />
                {isLoading && <p>Processing...</p>}
                {message && <div className="success-message">{message}</div>}
                {error && <div className="error-message">{error}</div>}
                <Box display="flex" gap={2}>
                  <Button
                    type="submit"
                    sx={{
                      backgroundColor: colors.blueAccent[700],
                      color: colors.primary[400],
                      fontSize: "14px",
                      fontWeight: "bold",
                      margin: "10px",
                    }}
                    variant="contained"
                  >
                    Save
                  </Button>

                  <Button
                    type="submit"
                    sx={{
                      backgroundColor: colors.blueAccent[700],
                      color: colors.primary[400],
                      fontSize: "14px",
                      fontWeight: "bold",
                      margin: "10px",
                    }}
                    variant="contained"
                    onClick={() => {
                      resetForm(); // Reset form when clicked
                    }}
                  >
                    Reset
                  </Button>
                </Box>
              </Box>
            </form>
          )}
        </Formik>
      ),
    },
  ];

  return (
    <Box m="20px">
      <Header title="Add Item Location" subtitle="Create a New Item Location" />
      <IconButton
        onClick={handleClose}
        sx={{
          position: "absolute",
          top: 10,
          right: 10,
        }}
      >
        <Typography
          sx={{ fontWeight: "bold", fontSize: "16px", marginRight: "5px" }}
        >
          Close
        </Typography>{" "}
        <CloseIcon />
      </IconButton>
      <Card>
        <CardContent>
          <Tabs value={activeTab} onChange={handleTabChange}>
            {tabContent.map((tab, index) => (
              <Tab
                key={index}
                label={tab.label}
                sx={{
                  color: activeTab === index ? "black" : colors.blueAccent[700], // Active tab color
                  fontWeight: activeTab === index ? "bold" : "normal", // Optional: Bold for active tab
                }}
              />
            ))}
          </Tabs>

          <Box mt="20px">{tabContent[activeTab].content}</Box>
        </CardContent>
      </Card>
    </Box>
  );
};

const overviewSchema = yup.object().shape({
  building: yup.string().required("Building information is required"),
  floor: yup.string().required("Floor information is required"),
  door: yup.string().required("Door information is required"),
});

const initialValues = {
  building: "",
  floor: "",
  door: "",
};

export default CreateItemLocation;
